<script setup>
import { reactive, watch } from 'vue'
import FieldPicker from '../shared/FieldPicker.vue'

const props = defineProps({
    node: Object,
})

const emit = defineEmits(['update:config'])

const form = reactive({
    date_field: props.node?.data?.config?.date_field ?? '',
    offset_days: props.node?.data?.config?.offset_days ?? 0,
    offset_direction: props.node?.data?.config?.offset_direction ?? 'on',
})

watch(() => props.node, (node) => {
    if (!node) return
    form.date_field = node.data?.config?.date_field ?? ''
    form.offset_days = node.data?.config?.offset_days ?? 0
    form.offset_direction = node.data?.config?.offset_direction ?? 'on'
})

function emitUpdate() {
    emit('update:config', {
        date_field: form.date_field,
        offset_days: Number(form.offset_days),
        offset_direction: form.offset_direction,
    })
}
</script>

<template>
    <div class="config-panel__section">
        <label class="config-panel__label">Date Field</label>
        <FieldPicker
            v-model="form.date_field"
            filter-type="date"
            placeholder="Select date field..."
            @update:modelValue="emitUpdate"
        />

        <label class="config-panel__label">Timing</label>
        <div class="wait-date__row">
            <select v-model="form.offset_direction" class="config-panel__select" @change="emitUpdate" style="flex: 1">
                <option value="before">Before</option>
                <option value="on">On</option>
                <option value="after">After</option>
            </select>
            <input
                v-if="form.offset_direction !== 'on'"
                v-model="form.offset_days"
                class="config-panel__input"
                type="number"
                min="0"
                placeholder="Days"
                @input="emitUpdate"
                style="flex: 1"
            />
        </div>
    </div>
</template>

<style scoped>
.wait-date__row {
    display: flex;
    gap: 8px;
    align-items: center;
}
</style>
